import z from 'zod'

export const RemoteConfigStates = ['public', 'preview'] as const

export const remoteConfigStateSchema = z
  .enum(RemoteConfigStates)
  .catch('public')

export type RemoteConfigState = z.infer<typeof remoteConfigStateSchema>

export const regionSchema = z.object({
  region: z.string().optional(),
})

export const idSchema = z.union([z.string(), z.number()])

export const remoteConfigParamsSchema = regionSchema.extend({
  versionId: idSchema.optional(),
  state: remoteConfigStateSchema.optional(),
})

export type RemoteConfigParams = z.infer<typeof remoteConfigParamsSchema>
